import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

function MobileMenu() {
  const auth = localStorage.getItem("user_id");
  const token = localStorage.getItem("accessToken");

  const menuGroups = [
    {
      title: "Announcements",
      icon: <i className="fa fa-bullhorn"></i>,
      items: [
        { links: `https://distributor.capnolearning.com/software-announcement?accessToken=${token}`, name: "Software Announcements", icon: <i className="fa fa-bullhorn"></i> },
        { links: `https://distributor.capnolearning.com/announcements?accessToken=${token}`, name: "Email Announcement", icon: <i className="fa-solid fa-envelope-open-text"></i> },
      ],
    },
    {
      title: "FAQ",
      icon: <i className="fa fa-question-circle"></i>,
      items: [
        { links: "/faq", name: "FAQs", icon: <i className="fa fa-question-circle"></i> },
        { links: "/category", name: "FAQ Categories", icon: <i className="fa fa-question-circle"></i> },
      ],
    },
    {
      title: "Recording",
      icon: <i className="fas fa-microphone"></i>,
      items: [
        { links: `https://distributor.capnolearning.com/recordings?accessToken=${token}`, name: "Recordings", icon: <i className="fas fa-microphone"></i> },
        { links: `https://distributor.capnolearning.com/tutorial-recordings?accessToken=${token}`, name: "Tutorial Recordings", icon: <i className="fas fa-video"></i> },
      ],
    },
    {
      title: "Shopping Cart",
      icon: <i className="fa-solid fas fa-box"></i>,
      items: [
        { links: "/products", name: "Products", icon: <i className="fa-solid fas fa-box"></i> },
        { links: "/Categroys", name: "Product Categories", icon: <i className="fa-solid fas fa-box"></i> },
        { links: "/coupon", name: "Discount Coupons", icon: <i className="fa-solid fa-tags"></i> },
        { links: "/Orders", name: "Orders", icon: <i className="fa-solid fas fa-boxes"></i> },
      ],
    },
    {
      title: "Software",
      icon: <i className="fa fa-gear"></i>,
      items: [
        { links: `https://distributor.capnolearning.com/software-update?accessToken=${token}`, name: "Software Updates", icon: <i className="fa fa-gear"></i> },
      ],
    },
    {
      title: "Subscription",
      icon: <i className="fa-solid fa-user"></i>,
      items: [
        { links: "/subscriber/user", name: "User Subscriptions", icon: <i className="fa-solid fa-user"></i> },
        { links: "/", name: "Group Subscriptions", icon: <i className="fa-solid fa-list-check"></i> },
        { links: "/manage/online/access", name: "Manage Online Access", icon: <i className="fa-solid fa-people-roof"></i> },
      ],
    },
  ];

  const othersMenu = [
    { links: "/affiliate", name: "Affiliates", icon: <i className="fa-solid fa-user"></i> },
    { links: `https://distributor.capnolearning.com/customers?accessToken=${token}`, name: "Customers", icon: <i className="fa fa-users" style={{marginLeft:"-1.5px",marginRight:"1.5px"}}></i> },
    { links: `https://distributor.capnolearning.com?accessToken=${token}`, name: "Devices", icon: <i className="fa-solid fa-list-check"></i> },
    { links: `https://distributor.capnolearning.com/distributors?accessToken=${token}`, name: "Distributors", icon: <i className="fas fa-user-friends" style={{fontSize:"13px"}}></i> },
    { links: `https://distributor.capnolearning.com/tech-support?accessToken=${token}`, name: "Tech Support", icon: <i className="fas fa-headset"></i> },
  ];

  // Merge and sort
  const combinedMenu = [
    ...menuGroups.map(group => ({
      title: group.title,
      icon: group.icon,
      items: group.items
    })),
    ...othersMenu.map(item => ({
      title: item.name,
      icon: item.icon,
      items: [item]
    }))
  ];

  combinedMenu.sort((a, b) => a.title.localeCompare(b.title));

  combinedMenu.forEach(menu => {
    menu.items.sort((a, b) => a.name.localeCompare(b.name));
  });

  const [openMenu, setOpenMenu] = useState(null);
useEffect(() => {
  combinedMenu.forEach(menu => {
    if (
      menu.items.some(item => {
        try {
          if (item.links.startsWith("/")) {
            // Internal link → match pathname
            // console.log(location.pathname,item.links,window.location.href.startsWith(item.links));
            
            return location.pathname == item.links;
          } else {
            // External link → match full href
            return window.location.href.startsWith(item.links);
          }
        } catch (err) {
          return false;
        }
      })
    ) {
    //   console.log("Opening menu:", menu.title);
      setOpenMenu(menu.title);
    }
  });
}, [location.pathname]);

  const toggleMenu = (title) => {
    setOpenMenu(openMenu === title ? null : title);
  };



  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <div className="left-list">
      <div className="list-wrp-mobile">
        <ul className="l-sideb-list">
          {combinedMenu.map((menu, gIndex) => (
            <li key={gIndex}>
              {menu.items.length > 1 ? (
                <>
                  <div
                    className="menu-item"
                    onClick={() => toggleMenu(menu.title)}
                  >
                    {menu.icon}
                    <span>{menu.title}</span>
                    <i className={`fa-solid ${openMenu === menu.title ? "fa-chevron-up" : "fa-chevron-down"}`} style={{ marginLeft: "auto" }}></i>
                  </div>
                  {openMenu === menu.title && (
                    <ul className="l-sideb-list" style={{ paddingLeft: "10px" }}>
                      {menu.items.map((item, iIndex) => (
                        <li key={iIndex}>
                          <NavLink to={item.links} activeClassName="active">
                            {item.icon}
                            <span style={{ marginLeft: "8px" }}>{item.name}</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <NavLink to={menu.items[0].links} activeClassName="active">
                  {menu.icon}
                  <span style={{ marginLeft: "8px" }}>{menu.items[0].name}</span>
                </NavLink>
              )}
            </li>
          ))}

          {auth && (
            <li>
              <Link to="/login" onClick={logout}>
                <i className="fa fa-sign-out" style={{marginLeft:"1.5px"}}></i>
                <span style={{ marginLeft: "8px" }}>Logout</span>
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default MobileMenu;
